(function () {
  'use strict';

  // Smooth scroll du scroll-indicator vers la section offres
  document.addEventListener('DOMContentLoaded', function () {

    // ─── Multiselect ─────────────────────────────────────────────────────────
    // Écouteurs délégués sur le document : la section offres est remplacée à
    // chaque recherche (voir « Recherche sans rechargement »), les composants
    // doivent fonctionner sans être réinitialisés.
    var closeMultiselect = function (ms) {
      ms.querySelector('.multiselect__dropdown').classList.remove('is-open');
      ms.querySelector('.multiselect__trigger').setAttribute('aria-expanded', 'false');
    };

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('.multiselect__trigger');
      var current = trigger ? trigger.closest('.multiselect') : null;

      // Fermer les composants ouverts hors de celui cliqué
      document.querySelectorAll('.multiselect').forEach(function (ms) {
        if (ms !== current && !ms.contains(e.target)) { closeMultiselect(ms); }
      });

      if (current) {
        var isOpen = current.querySelector('.multiselect__dropdown').classList.toggle('is-open');
        trigger.setAttribute('aria-expanded', isOpen);
      }
    });

    document.addEventListener('change', function (e) {
      var ms = e.target.closest('.multiselect');
      if (!ms) { return; }
      var labelEl = ms.querySelector('.multiselect__label');
      var checked = ms.querySelectorAll('input[type="checkbox"]:checked');
      if (checked.length === 0) {
        labelEl.textContent = ms.dataset.label || 'Sélectionner';
      } else {
        var noun = ms.dataset.noun || 'élément';
        labelEl.textContent = checked.length + ' ' + noun + (checked.length > 1 ? 's' : '');
      }
      ms.querySelectorAll('.multiselect__option').forEach(function (opt) {
        opt.classList.toggle('is-checked', opt.querySelector('input').checked);
      });
    });


    // ─── Persistance des filtres de recherche ─────────────────────────────────
    // Sauvegarde les paramètres URL quand on ouvre une offre
    document.addEventListener('click', function (e) {
      if (e.target.closest('.job-card__cta')) {
        sessionStorage.setItem('starter_search', window.location.search);
      }
    });

    // Restaure les paramètres sur le bouton "Retour aux offres" et le lien
    // « Offres » du fil d'ariane (page single)
    var savedSearch = sessionStorage.getItem('starter_search');
    if (savedSearch) {
      document.querySelectorAll('.btn-back, .breadcrumb__offers').forEach(function (backLink) {
        var baseUrl = backLink.href.split('?')[0].replace(/#.*$/, '');
        backLink.href = baseUrl + savedSearch + '#offres';
      });
    }

    // Arrivée sur une ancre (…/#offres) : le défilement doux natif vers la cible
    // est interrompu par le refresh de ScrollTrigger au « load » (scrollTo(0,0)
    // puis restauration de la position courante). On repositionne une fois
    // celui-ci passé, sans animation.
    if (window.location.hash.length > 1) {
      window.addEventListener('load', function () {
        window.setTimeout(function () {
          var anchorTarget = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
          if (anchorTarget) { anchorTarget.scrollIntoView({ behavior: 'instant', block: 'start' }); }
        }, 0);
      });
    }

    var scrollIndicator = document.querySelector('.hero__scroll-indicator');
    var offresSection = document.querySelector('.offres');

    if (scrollIndicator && offresSection) {
      scrollIndicator.addEventListener('click', function () {
        offresSection.scrollIntoView({ behavior: 'smooth' });
      });
    }

    // ─── Mini-carte localisation (MapLibre + OpenFreeMap, non interactive) ─────
    // Fond « Positron » d'OpenFreeMap : tuiles vectorielles OSM, open source, sans
    // clé d'API ni compte. Les libellés sont masqués pour un rendu épuré.
    document.querySelectorAll('.location-card__map').forEach(function (el) {
      if (typeof window.maplibregl === 'undefined') { return; }

      var lat  = parseFloat(el.dataset.lat);
      var lng  = parseFloat(el.dataset.lng);
      // data-zoom est exprimé en niveaux « raster 256 px » (Leaflet) : les tuiles
      // vectorielles sont en 512 px, d'où le -1 pour garder la même échelle.
      var zoom = parseInt(el.dataset.zoom || '13', 10) - 1;
      if (isNaN(lat) || isNaN(lng)) { return; }

      // Carte « statique » : toutes les interactions désactivées
      var map = new window.maplibregl.Map({
        container: el,
        style: 'https://tiles.openfreemap.org/styles/positron',
        center: [lng, lat],
        zoom: zoom,
        interactive: false,
        attributionControl: { compact: false }
      });

      // Masque les calques de texte/icônes (noms de rues, lieux, POI)
      map.on('style.load', function () {
        map.getStyle().layers.forEach(function (layer) {
          if ('symbol' === layer.type) {
            map.setLayoutProperty(layer.id, 'visibility', 'none');
          }
        });
      });

      // Cliquable → ouvre l'itinéraire dans un nouvel onglet
      var href = el.dataset.href;
      if (href) {
        el.style.cursor = 'pointer';
        var openMap = function () { window.open(href, '_blank', 'noopener'); };
        el.addEventListener('click', openMap);
        el.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openMap(); }
        });
      }
    });

    // ─── Favoris (localStorage) ────────────────────────────────────────────────
    // Écouteurs délégués + éléments relus à chaque appel : la grille, la barre
    // d'outils et la pagination sont remplacées à chaque recherche.
    var syncFavorites = (function () {
      var KEY = 'starter_favorites';
      var read = function () {
        try { return JSON.parse(window.localStorage.getItem(KEY)) || []; }
        catch (e) { return []; }
      };
      var write = function (arr) {
        try { window.localStorage.setItem(KEY, JSON.stringify(arr)); } catch (e) {}
      };

      var grid = function () { return document.querySelector('.job-grid'); };

      var isFavView = function () {
        var g = grid();
        return g && g.classList.contains('is-favorites-view');
      };

      var applyButton = function (btn, on) {
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        var lbl = btn.querySelector('.offre-fav__label');
        if (lbl) { lbl.textContent = on ? 'Offre sauvegardée' : "Sauvegarder l'offre"; }
      };

      // Filtre les cartes visibles en vue favoris
      var applyView = function () {
        var g = grid();
        if (!g || !isFavView()) { return; }
        var favs = read();
        var visible = 0;
        g.querySelectorAll('.job-card').forEach(function (card) {
          var b = card.querySelector('[data-fav-id]');
          var cid = b ? String(b.getAttribute('data-fav-id')) : '';
          var on = favs.indexOf(cid) !== -1;
          card.style.display = on ? '' : 'none';
          if (on) { visible++; }
        });
        var emptyMsg = document.querySelector('.favorites-empty');
        if (emptyMsg) { emptyMsg.hidden = visible !== 0; }
      };

      // État des boutons + compteur, d'après le localStorage
      var sync = function () {
        var favs = read();
        document.querySelectorAll('[data-fav-id]').forEach(function (btn) {
          applyButton(btn, favs.indexOf(String(btn.getAttribute('data-fav-id'))) !== -1);
        });
        var c = document.querySelector('.favorites-toggle__count');
        if (c) { c.textContent = favs.length; }
      };

      document.addEventListener('click', function (e) {
        // Cœur d'une offre
        var btn = e.target.closest('[data-fav-id]');
        if (btn) {
          e.preventDefault();
          e.stopPropagation();
          var id = String(btn.getAttribute('data-fav-id'));
          var list = read();
          var i = list.indexOf(id);
          if (i === -1) { list.push(id); } else { list.splice(i, 1); }
          write(list);
          sync();
          applyView(); // rafraîchit la vue favoris si active
          return;
        }

        // Bascule vue « Mes favoris »
        var favToggle = e.target.closest('.favorites-toggle');
        var g = grid();
        if (!favToggle || !g) { return; }
        var active = g.classList.toggle('is-favorites-view');
        var notice = document.querySelector('.favorites-notice');
        var emptyMsg = document.querySelector('.favorites-empty');
        var pagination = document.querySelector('.pagination');
        favToggle.classList.toggle('is-active', active);
        favToggle.setAttribute('aria-pressed', active ? 'true' : 'false');
        if (notice) { notice.hidden = !active; }
        if (pagination) { pagination.style.display = active ? 'none' : ''; }

        if (active) {
          applyView();
        } else {
          g.querySelectorAll('.job-card').forEach(function (card) { card.style.display = ''; });
          if (emptyMsg) { emptyMsg.hidden = true; }
        }
      });

      sync();
      return sync;
    })();

    // ─── Recherche sans rechargement ───────────────────────────────────────────
    // Recherche, tri, suppression d'un filtre et pagination : la page cible est
    // récupérée en fetch et seule la section offres est remplacée — pas de retour
    // en haut de page. L'URL est mise à jour (partage, bouton « Retour aux
    // offres », historique). En cas d'échec, repli sur la navigation classique.
    (function () {
      var section = document.getElementById('offres');
      if (!section || !window.fetch || !window.DOMParser || !window.history.pushState) { return; }

      var controller = null;

      // URL d'un formulaire GET, sans les champs vides (?keyword= inutile)
      var formUrl = function (form) {
        var url = new URL(form.getAttribute('action') || window.location.href, window.location.href);
        var params = new URLSearchParams();
        new FormData(form).forEach(function (value, key) {
          if ('' !== value) { params.append(key, value); }
        });
        url.search = params.toString();
        url.hash = '';
        return url.href;
      };

      // Refocalise l'équivalent de l'élément actif (sinon le focus tombe sur <body>)
      var restoreFocus = function (focusName, focusSubmit) {
        var target = null;
        if (focusSubmit) {
          target = section.querySelector('.search-form__submit');
        } else if (focusName) {
          target = section.querySelector('[name="' + focusName.replace(/"/g, '\\"') + '"]');
        }
        if (!target) {
          // Lien (chip, pagination) : on annonce le nouveau nombre de résultats
          target = section.querySelector('.offres__count');
          if (target) { target.setAttribute('tabindex', '-1'); }
        }
        if (target) { target.focus({ preventScroll: true }); }
      };

      var load = function (url, push) {
        if (controller) { controller.abort(); }
        controller = new AbortController();

        var active = document.activeElement;
        var hadFocus = active && section.contains(active);
        var focusName = hadFocus && active.name ? active.name : '';
        var focusSubmit = hadFocus && active.classList.contains('search-form__submit');

        section.classList.add('is-loading');
        section.setAttribute('aria-busy', 'true');

        fetch(url, { signal: controller.signal, credentials: 'same-origin' })
          .then(function (res) {
            if (!res.ok) { throw new Error(res.status); }
            return res.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.getElementById('offres');
            if (!fresh) { throw new Error('#offres absent'); }

            section.className = fresh.className;
            section.replaceChildren.apply(section, Array.prototype.slice.call(fresh.childNodes));
            section.removeAttribute('aria-busy');
            if (push) { window.history.pushState({ offres: true }, '', url); }

            syncFavorites();
            if (hadFocus) { restoreFocus(focusName, focusSubmit); }

            // Pagination / chip cliqués en bas de liste : on remonte au début des résultats
            if (section.getBoundingClientRect().top < 0) {
              section.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }

            // Les déclencheurs GSAP situés sous la section ont bougé
            if (window.ScrollTrigger) { window.ScrollTrigger.refresh(); }
          })
          .catch(function (err) {
            if (err && 'AbortError' === err.name) { return; }
            window.location.href = url;
          });
      };

      section.addEventListener('submit', function (e) {
        var form = e.target.closest('.search-form, .offres__sort');
        if (!form) { return; }
        e.preventDefault();
        section.querySelectorAll('.multiselect').forEach(closeMultiselect);
        load(formUrl(form), true);
      });

      // Tri : soumission au changement (le formulaire n'a pas de bouton)
      section.addEventListener('change', function (e) {
        if (e.target.matches('.offres__sort-select')) {
          load(formUrl(e.target.form), true);
        }
      });

      section.addEventListener('click', function (e) {
        var link = e.target.closest('.active-filters a, .pagination a');
        if (!link || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
        e.preventDefault();
        load(link.href, true);
      });

      // Précédent / suivant du navigateur
      window.history.replaceState({ offres: true }, '', window.location.href);
      window.addEventListener('popstate', function (e) {
        if (e.state && e.state.offres) { load(window.location.href, false); }
      });
    })();

    // ─── Copier le lien de l'offre ─────────────────────────────────────────────
    document.querySelectorAll('.share__copy').forEach(function (btn) {
      var fallbackCopy = function (text) {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(ta);
      };
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-copy') || window.location.href;
        var done = function () {
          btn.classList.add('is-copied');
          btn.setAttribute('aria-label', 'Lien copié');
          window.setTimeout(function () {
            btn.classList.remove('is-copied');
            btn.setAttribute('aria-label', 'Copier le lien');
          }, 1800);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(done).catch(function () { fallbackCopy(url); done(); });
        } else {
          fallbackCopy(url);
          done();
        }
      });
    });

    // ─── Slider offres similaires (Swiper) ─────────────────────────────────────
    if (typeof window.Swiper !== 'undefined' && document.querySelector('.similar-offers__swiper')) {
      new window.Swiper('.similar-offers__swiper', {
        slidesPerView: 1,
        spaceBetween: 24,
        grabCursor: true,
        navigation: {
          nextEl: '.similar-offers .swiper-button-next',
          prevEl: '.similar-offers .swiper-button-prev'
        },
        pagination: {
          el: '.similar-offers .swiper-pagination',
          clickable: true
        },
        breakpoints: {
          640:  { slidesPerView: 2 }
        }
      });
    }

    // ─── Carrousel logos partenaires (Swiper) ──────────────────────────────────
    var partnersSwiper = document.querySelector('.partners__swiper');
    if (typeof window.Swiper !== 'undefined' && partnersSwiper) {
      var pauseOnHover = partnersSwiper.getAttribute('data-pause-on-hover') === '1';

      // Boucle fluide sans trou : sur desktop, quelques logos tiennent dans la
      // largeur du conteneur — la bande ne déborde pas et rien ne défile. On
      // duplique donc les logos jusqu'à ce que la bande dépasse largement le
      // conteneur (Swiper a alors de quoi enchaîner la boucle en continu).
      var pWrapper = partnersSwiper.querySelector('.swiper-wrapper');
      if (pWrapper) {
        var originals = Array.prototype.slice.call(pWrapper.children);
        var containerW = partnersSwiper.clientWidth || window.innerWidth || 0;
        // Largeur d'un jeu de logos (padding pris en compte même image non chargée).
        var setW = 0;
        originals.forEach(function (slide) { setW += (slide.offsetWidth || 160) + 32; });
        // Cible : bande ≥ 2,5× le conteneur, entre 2 et 12 jeux au total.
        var totalSets = setW > 0 ? Math.ceil((containerW * 2.5) / setW) : 3;
        totalSets = Math.min(Math.max(totalSets, 2), 12);
        for (var p = 1; p < totalSets; p++) {
          originals.forEach(function (slide) {
            pWrapper.appendChild(slide.cloneNode(true));
          });
        }
      }

      var partnersSw = new window.Swiper(partnersSwiper, {
        slidesPerView: 'auto',
        spaceBetween: 32,
        loop: true,
        grabCursor: false,
        speed: 4000,
        allowTouchMove: false,
        autoplay: {
          delay: 0,
          disableOnInteraction: false,
          pauseOnMouseEnter: pauseOnHover
        },
        on: {
          init: function () {
            if (this.autoplay) { this.autoplay.start(); }
          }
        }
      });

      // Filet de sécurité : avec delay:0, l'autoplay ne s'amorce pas toujours
      // à l'initialisation — on le relance explicitement.
      if (partnersSw && partnersSw.autoplay) {
        partnersSw.autoplay.start();
      }
    }

    // ─── Menu mobile (toggle) ──────────────────────────────────────────────────
    var burger = document.querySelector('.site-header__burger');
    var mobileMenu = document.getElementById('mobile-menu');
    if (burger && mobileMenu) {
      var setMenu = function (open) {
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
        burger.classList.toggle('is-open', open);
        document.body.classList.toggle('menu-open', open);
        if (open) {
          mobileMenu.hidden = false;
          // force reflow puis classe pour la transition
          void mobileMenu.offsetWidth;
          mobileMenu.classList.add('is-open');
        } else {
          mobileMenu.classList.remove('is-open');
          window.setTimeout(function () {
            if (!mobileMenu.classList.contains('is-open')) { mobileMenu.hidden = true; }
          }, 300);
        }
      };

      burger.addEventListener('click', function () {
        setMenu(burger.getAttribute('aria-expanded') !== 'true');
      });

      // Fermer au clic sur un lien du menu
      mobileMenu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () { setMenu(false); });
      });

      // Fermer avec Échap
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && burger.getAttribute('aria-expanded') === 'true') {
          setMenu(false);
        }
      });
    }

    // ─── Scroll-spy des liens d'ancre du menu ──────────────────────────────────
    // Les liens de menu qui pointent vers une section de la page courante
    // (#offres, #chiffres-cles…) ne peuvent pas être gérés par le
    // « current-menu-item » de WordPress : core ignore le fragment, donc toutes les
    // ancres d'une même page seraient actives en même temps (cf. le filtre
    // starter_fix_anchor_menu_classes dans functions.php). On détermine donc la
    // section active au scroll et on pose « is-current » sur un seul <li> à la fois.
    var spyTargets = (function () {
      var links = document.querySelectorAll(
        '.site-header__nav-list a[href*="#"],' +
        '.mobile-menu__list a[href*="#"],' +
        '.site-footer__nav-list a[href*="#"]'
      );
      // Une même section est visée par plusieurs menus (desktop + mobile + footer) :
      // on regroupe pour activer tous les <li> correspondants d'un coup.
      var bySection = [];
      var index = {};

      // Normalise le slash final : selon la config des permaliens, le href du menu et
      // location.pathname peuvent différer sur ce seul caractère, ce qui désactiverait
      // le scroll-spy silencieusement.
      var samePath = function (a, b) {
        return a.replace(/\/+$/, '') === b.replace(/\/+$/, '');
      };

      Array.prototype.forEach.call(links, function (link) {
        // Écarte les ancres inter-pages : seul le fragment de la page courante compte.
        if (!samePath(link.pathname, window.location.pathname)) { return; }

        var id = link.hash.slice(1);
        if (!id) { return; }

        var section = document.getElementById(id);
        var item = link.closest('li');
        if (!section || !item) { return; }

        if (index[id] === undefined) {
          index[id] = bySection.length;
          bySection.push({ section: section, items: [], links: [] });
        }
        bySection[index[id]].items.push(item);
        bySection[index[id]].links.push(link);
      });

      // Ordre du DOM : l'ordre des sections est piloté par le Customizer
      // (starter_section_order), il ne doit jamais être codé en dur.
      bySection.sort(function (a, b) {
        return (a.section.compareDocumentPosition(b.section) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
      });

      return bySection;
    })();

    var setActiveSpy = function (activeIndex) {
      spyTargets.forEach(function (target, i) {
        var on = i === activeIndex;
        target.items.forEach(function (item) { item.classList.toggle('is-current', on); });
        target.links.forEach(function (link) {
          if (on) { link.setAttribute('aria-current', 'location'); }
          else { link.removeAttribute('aria-current'); }
        });
      });
    };

    // Offset du header sticky : lu depuis le CSS (scroll-padding-top, _reset.scss)
    // pour rester la seule source de vérité — 130px desktop, 118px sous 768px.
    var spyOffset = function () {
      var declared = parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop);
      return isNaN(declared) ? 130 : declared;
    };

    // Verrou après un clic : le smooth scroll traverse les sections intermédiaires,
    // qui clignoteraient. On fige la cible cliquée le temps du défilement.
    var spyLockUntil = 0;

    if (spyTargets.length) {
      spyTargets.forEach(function (target, i) {
        target.links.forEach(function (link) {
          link.addEventListener('click', function () {
            setActiveSpy(i);
            spyLockUntil = Date.now() + 600;
          });
        });
      });
    }

    var updateSpy = function () {
      if (!spyTargets.length || Date.now() < spyLockUntil) { return; }

      var probe = spyOffset() + 8;
      var active = 0;

      // Dernière section dont le haut est passé sous la ligne de sonde. Les rects
      // sont relus à chaque tick (≈7 sections) plutôt que mis en cache : immunise
      // contre les décalages de layout (images, polices, animations GSAP).
      for (var i = 0; i < spyTargets.length; i++) {
        if (spyTargets[i].section.getBoundingClientRect().top <= probe) { active = i; }
      }

      // Bas de page : sans ça, une dernière section plus courte que le viewport
      // ne peut jamais devenir active.
      if (window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 2) {
        active = spyTargets.length - 1;
      }

      setActiveSpy(active);
    };

    // Header : changer l'opacité au scroll
    var header = document.querySelector('.site-header');

    var updateHeader = function () {
      if (!header) { return; }
      if (window.scrollY > 50) {
        header.style.background = 'rgba(255, 255, 255, 0.92)';
      } else {
        header.style.background = 'rgba(255, 255, 255, 0.44)';
      }
    };

    // Un seul listener scroll pour l'opacité du header et le scroll-spy,
    // throttlé en requestAnimationFrame.
    if (header || spyTargets.length) {
      var ticking = false;

      var onScroll = function () {
        if (ticking) { return; }
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          updateHeader();
          updateSpy();
        });
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      updateHeader();
      updateSpy();
    }
  });
})();
